// This icon file is generated automatically.
var PAlignRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.13 1.47H5.37a.13.13 0 00-.12.12v.88c0 .07.06.12.13.12h7.75c.06 0 .12-.05.12-.12v-.88a.13.13 0 00-.13-.12zm0 6.62H5.37a.13.13 0 00-.12.13v.87c0 .07.06.13.13.13h7.75c.06 0 .12-.06.12-.13v-.87a.13.13 0 00-.13-.13zm0 3.32H.87a.13.13 0 00-.12.12v.88c0 .06.06.12.13.12h12.24c.07 0 .13-.05.13-.12v-.88a.13.13 0 00-.13-.12zm0-6.63H.87a.13.13 0 00-.12.13v.87c0 .07.06.13.13.13h12.24c.07 0 .13-.06.13-.13v-.87a.13.13 0 00-.13-.13z", "fill-rule": "nonzero" } }] }, "name": "p-align-right", "theme": "outlined" };
export default PAlignRightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PAlignRightOutlined.js
// module id = 3207
// module chunks = 0